import React from 'react';
import MUISwitch from '@mui/material/Switch';
import { alpha, styled } from '@mui/material/styles';

const ColoredSwitch = styled(MUISwitch)(({ theme }) => ({
  '& .MuiSwitch-switchBase.Mui-checked': {
    color: '#26796b',
    '&:hover': {
      backgroundColor: alpha('#26796b', theme.palette.action.hoverOpacity),
    },
  },
  '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
    backgroundColor: '#26796b',
  },
  '& .MuiSwitch-switchBase.Mui-disabled': {
    color: '#e5e5ea',
  },
  '& .MuiSwitch-switchBase.Mui-disabled + .MuiSwitch-track': {
    backgroundColor: '#989899',
  },
}));

const Switch = ({ onChange, checked, defaultChecked, disabled = false }) => {
  return <ColoredSwitch checked={checked} onChange={onChange} defaultChecked={defaultChecked} disabled={disabled} />;
};

export default Switch;
